/**
 * @author: leroy
 * @date: 2021/11/3 11:22
 * @description：Home
 */
import { makeAutoObservable, runInAction } from 'mobx';
import type { SubmitListType } from '@/store/services/submit';
import { fetchPositionList } from '@/store/services/submit';

export class SubmitStore {
  public positionList: SubmitListType.Datum[] = [] as any;

  constructor() {
    makeAutoObservable(this);
  }

  setData({ key, value }: { key: keyof SubmitStore; value: any }) {
    this[key] = value;
  }

  hydrate = (data) => {
    if (!data) return;
    Object.entries(data).forEach(([key, value]) => {
      this[key] = value;
    });
  };

  fetchList = async (params) => {
    try {
      const { data } = await fetchPositionList(params);
      runInAction(() => {
        this.positionList = data!;
      });
      return data;
    } catch (error) {
      console.log('fetchList', error);
    }
  };
}

export default SubmitStore;
